import React, { memo } from 'react';
import { Text } from '@Sage/hoi-poi-ui';

import { buildReviewSummarySegments } from './helpers';

const ReviewSummaryText = memo(({ segments, type }) => (
    <Text type={type} className="fm-text-inlineGap">
        {segments.map((segment, index) =>
            segment.bold != null ? (
                <Text key={`b-${index}`} type={type} bold as="span">
                    {segment.bold}
                </Text>
            ) : (
                <span key={`t-${index}`}>{segment.text}</span>
            ),
        )}
    </Text>
));

const ReviewSummary = ({ readyCount, createdCount, failedCount, creditsUsed, balance }) => {
    const { titleSegments, statsSegments } = buildReviewSummarySegments({
        readyCount,
        createdCount,
        failedCount,
        creditsUsed,
        balance,
    });

    return (
        <>
            <ReviewSummaryText segments={titleSegments} type="h6" />
            <ReviewSummaryText segments={statsSegments} type="caption" />
        </>
    );
};

export default memo(ReviewSummary);
